import { Routes, RouterModule } from '@angular/router';
import { AdministrarCodigoReutilizableComponent } from './administrar-codigo-reutilizable.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  { path: '', component: AdministrarCodigoReutilizableComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class AdministrarCodigoReutilizableRouting { }
